import React from 'react';
import './login.css';
// import { GoogleLogin } from 'react-google-login';
import { Redirect } from 'react-router-dom';
import logo from '../../images/ACT-logo.png'
import NADCPLogo from '../../images/AllRise-Color.png'

const responseGoogle = (response) => {
    //Need to do something else here.
    console.log(response);
}

class Login extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: ''
        };
    }

    onChangeUsername = event => {
        const username = event.target.value;
        this.setState({ username });
    };

    onChangePassword = event => {
        const password = event.target.value;
        this.setState({ password });
    };

    onKeyPress = e => e.key === "Enter" && this.props.actions.authenticate(this.state.username, this.state.password);

    render() {
        return (

            this.props.isAuthenticated ? <Redirect to='/programs' /> :
                <div className='login-container'>
                    <img src={NADCPLogo} alt='Logo' className={'login-logo'} style={{ height: '100px' }} />
                    <div className='login-component'>
                        <h2>LOG IN TO ALL RISE</h2>
                        <div className='login-cap'></div>
                        <div className='login-body'>
                            <span>{this.props.loginMessage}</span>
                            <div>
                                <input value={this.state.username} type="text" onChange={this.onChangeUsername} onKeyPress={this.onKeyPress} placeholder={'Username'} />
                                <input value={this.state.password} type="password" onChange={this.onChangePassword} onKeyPress={this.onKeyPress} placeholder={'Password'} />
                            </div>
                            <button className='login-button' type='button' onClick={() => {
                                this.props.actions.authenticate(this.state.username, this.state.password);
                            }}>LOGIN</button>

                            {/* {process.env.REACT_APP_GOOGLE_LOGIN_ENABLED === 'true' && <GoogleLogin className='login-googlebutton'
                                type="link"
                                clientId={process.env.REACT_APP_GOOGLE_API_KEY}
                                buttonText='Login with Google'
                                onSuccess={(response) => { this.props.actions.authenticateGoogle(response); }}
                                onFailure={responseGoogle}
                            />} */}
                        </div>
                    </div >
                    <img src={logo} alt='Logo' className={'login-logo'} style={{ height: '50px' }} />
                </div>
        );
    }
}

export default Login;